"use client";

import type React from "react";

/**
 * Lightweight no-op wrapper for landing pages.
 *
 * Why:
 * - `framer-motion` + `useInView` added significant JS/CPU cost and caused large
 *   cold-start Lighthouse variance on mobile.
 * - For performance-first builds, we render content immediately without JS-driven
 *   scroll animations.
 */
export function ScrollAnimation({
  children,
  className = "",
}: {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  direction?: "up" | "down" | "left" | "right";
  stagger?: boolean;
}) {
  return <div className={className}>{children}</div>;
}
